// Disables a clicked button until the request it triggered settles
// (see core/http/request.js), or for 500ms if it triggered none.
let pendingBtn = null;

function capturePendingBtn(btn) {
    pendingBtn = btn;
}

function takePendingBtn() {
    const btn = pendingBtn;
    pendingBtn = null;
    return btn;
}

export function installButtonLock() {
    window.__btnLock = { capturePendingBtn, takePendingBtn };

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('button');
        if (!btn || btn.disabled || btn.classList.contains('is-clicking')) return;
        btn.classList.add('is-clicking');
        capturePendingBtn(btn);
        btn.__unlockTimer__ = setTimeout(() => btn.classList.remove('is-clicking'), 500);
    }, true);
}
